import type { ValidationErrors } from './validation';

export function renameErrorKeys(errors: ValidationErrors, oldKey: string, newKey: string) {
    return errors
        .mapKeys((key) => {
            if (key && key.match(RegExp('^' + oldKey + '[/d]*'))) {
                return key.replace(RegExp(oldKey), newKey);
            }

            return key!;
        })
        .toMap();
}
